var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cost-mapping-form text-left"
  }, [_c('p', {
    staticClass: "text-lg font-bold mb-6"
  }, [_vm._v("Tambahkan Cost")]), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('div', {
    staticClass: "mb-6 relative"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kota Asal")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "withIcon": "",
      "type": "text",
      "placeholder": "Pilih kota asal",
      "disabled": _vm.isEditMode
    },
    on: {
      "input": function ($event) {
        return _vm.searchCity($event, 'origin');
      }
    },
    model: {
      value: _vm.originSearch,
      callback: function ($$v) {
        _vm.originSearch = $$v;
      },
      expression: "originSearch"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1), _vm.isSearching['origin'] ? _c('img', {
    staticClass: "w-8 absolute top-1/2 transform -translate-y-1/2 right-2",
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.visibleSuggestion['origin'] ? _c('div', {
    staticClass: "mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white"
  }, [_vm.cities ? _c('ul', {
    staticClass: "max-h-40 overflow-y-scroll"
  }, _vm._l(_vm.cities, function (city, index) {
    return _c('li', {
      key: 'city-' + index,
      staticClass: "cursor-pointer px-3 py-2 hover:bg-neutral-300",
      on: {
        "click": function ($event) {
          return _vm.selectCity(city, 'origin');
        }
      }
    }, [_vm._v(" " + _vm._s(city.village) + ", " + _vm._s(city.area_display) + " ")]);
  }), 0) : _c('div', {
    staticClass: "py-4 text-center"
  }, [_vm._v(" Maaf data tidak ditemukan! ")])]) : _vm._e()])], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.errors['origin_city'] ? _c('div', {
    staticClass: "text-system-error text-left mt-1 text-sm"
  }, [_vm._v(_vm._s(_vm.errors['origin_city']))]) : _vm._e()])], 1), _c('div', {
    staticClass: "mb-6 text-left relative"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kota Tujuan")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "withIcon": "",
      "type": "text",
      "disabled": _vm.isEditMode,
      "placeholder": "Pilih kota tujuan"
    },
    on: {
      "input": function ($event) {
        return _vm.searchCity($event, 'destination');
      }
    },
    model: {
      value: _vm.destinationSearch,
      callback: function ($$v) {
        _vm.destinationSearch = $$v;
      },
      expression: "destinationSearch"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1), _vm.isSearching['destination'] ? _c('img', {
    staticClass: "w-8 absolute top-1/2 transform -translate-y-1/2 right-2",
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.visibleSuggestion['destination'] ? _c('div', {
    staticClass: "mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white"
  }, [_vm.cities ? _c('ul', {
    staticClass: "max-h-40 overflow-y-scroll"
  }, _vm._l(_vm.cities, function (city, index) {
    return _c('li', {
      key: 'city-' + index,
      staticClass: "cursor-pointer px-3 py-2 hover:bg-neutral-300",
      on: {
        "click": function ($event) {
          return _vm.selectCity(city, 'destination');
        }
      }
    }, [_vm._v(" " + _vm._s(city.village) + ", " + _vm._s(city.area_display) + " ")]);
  }), 0) : _c('div', {
    staticClass: "py-4 text-center"
  }, [_vm._v(" Maaf data tidak ditemukan! ")])]) : _vm._e()])], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.errors['destination_city'] ? _c('div', {
    staticClass: "text-system-error text-left mt-1 text-sm"
  }, [_vm._v(_vm._s(_vm.errors['destination_city']))]) : _vm._e()])], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Harga Per 1 Kg")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "withIcon": "",
      "placeholder": "Harga dalam satuan rupiah"
    },
    model: {
      value: _vm.payloads.cost_per_weight,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "cost_per_weight", _vm._n($$v));
      },
      expression: "payloads.cost_per_weight"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v(" Rp ")])], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.errors['cost_per_weight'] ? _c('div', {
    staticClass: "text-system-error text-left mt-1 text-sm"
  }, [_vm._v(_vm._s(_vm.errors['cost_per_weight']))]) : _vm._e()])], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Komponen Harga")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "withIcon": "",
      "placeholder": "Harga dalam satuan rupiah"
    },
    model: {
      value: _vm.payloads.base_cost,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "base_cost", _vm._n($$v));
      },
      expression: "payloads.base_cost"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v(" Rp ")])], 1), _c('span', {
    staticClass: "text-xs text-gray-500 leading-tight inline-block mt-1"
  }, [_vm._v("Pembagi berat vol matrix, (PxLxT / Nilai di atas)")]), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.errors['base_cost'] ? _c('div', {
    staticClass: "text-system-error text-left mt-1 text-sm"
  }, [_vm._v(_vm._s(_vm.errors['base_cost']))]) : _vm._e()])], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Harga Dimensi Kecil")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "withIcon": "",
      "placeholder": "Harga dalam satuan rupiah"
    },
    model: {
      value: _vm.payloads.cost_volume_small,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "cost_volume_small", _vm._n($$v));
      },
      expression: "payloads.cost_volume_small"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v(" Rp ")])], 1), _c('span', {
    staticClass: "text-xs text-gray-500 leading-tight inline-block mt-1"
  }, [_vm._v("Ukuran yang telah ditetapkan yaitu : 20x20x8 cm")]), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.errors['cost_volume_small'] ? _c('div', {
    staticClass: "text-system-error text-left mt-1 text-sm"
  }, [_vm._v(_vm._s(_vm.errors['cost_volume_small']))]) : _vm._e()])], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Harga Dimensi Menengah")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "withIcon": "",
      "placeholder": "Harga dalam satuan rupiah"
    },
    model: {
      value: _vm.payloads.cost_volume_medium,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "cost_volume_medium", _vm._n($$v));
      },
      expression: "payloads.cost_volume_medium"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v(" Rp ")])], 1), _c('span', {
    staticClass: "text-xs text-gray-500 leading-tight inline-block mt-1"
  }, [_vm._v("Ukuran yang telah ditetapkan yaitu: 30x22x12 cm")]), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.errors['cost_volume_medium'] ? _c('div', {
    staticClass: "text-system-error text-left mt-1 text-sm"
  }, [_vm._v(_vm._s(_vm.errors['cost_volume_medium']))]) : _vm._e()])], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Harga Dimensi Besar")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "withIcon": "",
      "placeholder": "Harga dalam satuan rupiah"
    },
    model: {
      value: _vm.payloads.cost_volume_large,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "cost_volume_large", _vm._n($$v));
      },
      expression: "payloads.cost_volume_large"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v(" Rp ")])], 1), _c('span', {
    staticClass: "text-xs text-gray-500 leading-tight inline-block mt-1"
  }, [_vm._v("Ukuran yang telah ditetapkan yaitu: 35x30x25 cm")]), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.errors['cost_volume_large'] ? _c('div', {
    staticClass: "text-system-error text-left mt-1 text-sm"
  }, [_vm._v(_vm._s(_vm.errors['cost_volume_large']))]) : _vm._e()])], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Estimasi Waktu Pengiriman")]), _c('div', {
    staticClass: "flex justify-between gap-6 items-center"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "Waktu minimum (cth: 24)"
    },
    model: {
      value: _vm.est_delivery_time_range_min,
      callback: function ($$v) {
        _vm.est_delivery_time_range_min = $$v;
      },
      expression: "est_delivery_time_range_min"
    }
  }), _c('span', {
    staticClass: "text-xs text-gray-500 leading-tight inline-block mt-1"
  }, [_vm._v("Dalam Jam")]), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.errors['est_delivery_time_range_min'] ? _c('div', {
    staticClass: "text-system-error text-left mt-1 text-sm"
  }, [_vm._v(_vm._s(_vm.errors['est_delivery_time_range_min']))]) : _vm._e()])], 1), _c('div', {
    staticClass: "flex-1"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "Waktu maximum (cth: 48)"
    },
    model: {
      value: _vm.est_delivery_time_range_max,
      callback: function ($$v) {
        _vm.est_delivery_time_range_max = $$v;
      },
      expression: "est_delivery_time_range_max"
    }
  }), _c('span', {
    staticClass: "text-xs text-gray-500 leading-tight inline-block mt-1"
  }, [_vm._v("Dalam Jam")]), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.errors['est_delivery_time_range_max'] ? _c('div', {
    staticClass: "text-system-error text-left mt-1 text-sm"
  }, [_vm._v(_vm._s(_vm.errors['est_delivery_time_range_max']))]) : _vm._e()])], 1)])]), _c('div', {
    staticClass: "mb-10"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Berat Barang")]), _c('div', {
    staticClass: "flex justify-between gap-6 items-center"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "Berat minimum"
    },
    model: {
      value: _vm.payloads.minimum_weight,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "minimum_weight", _vm._n($$v));
      },
      expression: "payloads.minimum_weight"
    }
  }), _c('span', {
    staticClass: "text-xs text-gray-500 leading-tight inline-block mt-1"
  }, [_vm._v("Set minimum dalam kg")]), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.errors['minimum_weight'] ? _c('div', {
    staticClass: "text-system-error text-left mt-1 text-sm"
  }, [_vm._v(_vm._s(_vm.errors['minimum_weight']))]) : _vm._e()])], 1), _c('div', {
    staticClass: "flex-1"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "Berat maximum"
    },
    model: {
      value: _vm.payloads.maximum_weight,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "maximum_weight", _vm._n($$v));
      },
      expression: "payloads.maximum_weight"
    }
  }), _c('span', {
    staticClass: "text-xs text-gray-500 leading-tight inline-block mt-1"
  }, [_vm._v("Set maximum dalam kg")]), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.errors['maximum_weight'] ? _c('div', {
    staticClass: "text-system-error text-left mt-1 text-sm"
  }, [_vm._v(_vm._s(_vm.errors['maximum_weight']))]) : _vm._e()])], 1)])]), _vm.generalError ? _c('div', {
    staticClass: "text-system-error text-center mb-10 text-sm"
  }, [_vm._v(_vm._s(_vm.generalError))]) : _vm._e(), _c('div', {
    staticClass: "flex justify-end gap-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Batal",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.close();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": _vm.isEditMode ? 'Update' : 'Simpan',
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.save();
      }
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }